import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { useToasts } from 'react-toast-notifications'

import { WarningModal } from '../../../ui'

export const DeleteNoteModal = ({
  note,
  name,
  isVisible,
  setModalVisibility,
  submitResponse,
  setNoteToDelete,
}) => {
  const { addToast } = useToasts()
  const [backEndErrors, setBackEndErrors] = React.useState({})

  const DeleteNote = async id => {
    axios({
      method: 'post',
      url: `/v1/candidates/notes/${id}/delete`,
    })
      .then(response => {
        if (response.data.success) {
          submitResponse(note, 'delete')
          setModalVisibility(false)
          addToast('Note deleted successfully', { appearance: 'success' })
          setNoteToDelete({})
        } else {
          addToast('Error deleting note, please try again', {
            appearance: 'error',
          })
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 422) {
          setBackEndErrors(error.response.data.errors)
        } else {
          setBackEndErrors(error.response.data.error)
          addToast(`Error deleting note, please try again`, {
            appearance: 'error',
          })
        }
      })
  }

  return (
    <WarningModal
      isVisible={isVisible}
      heading="Delete Note?"
      closeFunc={() => {
        setModalVisibility(false)
        setNoteToDelete({})
      }}
      submitButtonText="Delete note"
      submitFunc={() => DeleteNote(note.id)}
      backEndErrors={backEndErrors}
    >
      <b>{name}</b> will no longer exist
    </WarningModal>
  )
}

DeleteNoteModal.propTypes = {
  note: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
  setModalVisibility: PropTypes.func.isRequired,
  submitResponse: PropTypes.func.isRequired,
  setNoteToDelete: PropTypes.func.isRequired,
}
